export const ACCESS_CONTROL = [
  {
    label: "公開",
    value: "public",
  },
  {
    label: "非公開",
    value: "private",
  },
];

export const PROPERTY_VISIBILITY = {
  Limited: "LIMITED",
  Private: "PRIVATE",
  Public: "PUBLIC",
};

export const PROPERTY_VISIBILITY_OPTIONS = [
  {
    label: "公開",
    value: PROPERTY_VISIBILITY.Public,
  },
  {
    label: "限定公開",
    value: PROPERTY_VISIBILITY.Limited,
  },
  {
    label: "非公開",
    value: PROPERTY_VISIBILITY.Private,
  },
];
